import React from "react";
import { Sparkles, RefreshCw } from "lucide-react";

const TEXTURE = "https://static.prod-images.emergentagent.com/jobs/ba076ba6-cbb6-4319-9066-aa1342f64d2e/images/081040ebe7a7c84b8ab2b0fe8035be59edefdf550c49e2fe2ad159853745d85d.jpeg";

export const EncouragementBanner = ({ message, loading, targetMet, onRefresh }) => {
  return (
    <div
      className="relative overflow-hidden rounded-2xl border border-[#E5E1D8] p-8 shadow-[0_8px_30px_-10px_rgba(44,53,41,0.12)]"
      style={{ backgroundColor: targetMet ? "#E7EEE3" : "#EAE5D9" }}
      data-testid="encouragement-banner"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{
          backgroundImage: `url(${TEXTURE})`,
          backgroundSize: "cover",
          backgroundPosition: "center right",
          maskImage: "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0) 68%)",
          WebkitMaskImage: "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0) 68%)",
        }}
      />
      <div className="pointer-events-none absolute -left-16 -top-16 h-56 w-56 rounded-full bg-white/40 blur-3xl" />
      <div className="relative flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="mt-1 rounded-full bg-white/80 p-2 shadow-sm">
            <Sparkles className="h-4 w-4 text-brand" />
          </div>
          <div>
            <p className="mb-2 font-sans text-xs uppercase tracking-[0.18em] text-ink-muted">
              {targetMet ? "Target reached" : "A word for you"}
            </p>
            {loading ? (
              <p className="font-serif text-xl italic text-ink-soft">Listening for a gentle word…</p>
            ) : (
              <p className="max-w-2xl font-serif text-2xl leading-snug text-ink sm:text-3xl" data-testid="encouragement-text">
                “{message}”
              </p>
            )}
          </div>
        </div>
        <button
          onClick={onRefresh}
          disabled={loading}
          className="shrink-0 rounded-full bg-white/80 p-2 text-ink-soft shadow-sm transition-colors duration-300 hover:bg-white disabled:opacity-50"
          data-testid="refresh-encouragement-btn"
          aria-label="Refresh encouragement"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>
    </div>
  );
};
